import { type Employees } from 'modules/employees/store/collections/employees'

import { membershipEmployee } from './membershipEmployee'
import type Membership from './models/Membership'

export const membershipIsLead = (employees: Employees, membership: Membership) => {
  const employee = membershipEmployee(employees, membership)
  return !employee.isTerminated && membership.attributes.lead
}
